export const Error500Icon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    aria-label='500 Error'
    // width='320'
    // height='110'
    className={props.className}
    fill='none'
    role='img'
    viewBox='0 0 320 110'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>500 Error Icon</title>
    <path
      d='M238.042 31.227c1.944.72 4.067.768 6.088.305 8.467-1.937 37.582-7.07 32.523 15.428-1.102 4.463-18.153 29.461 6.13 38.585a16.8 16.8 0 0 0 5.565 1.093c7.477.154 22.293-1.607 28.493-7.9 7.491-7.604-.693-3.998-.693-3.998s-28.477 12.392-38.536-.756c-1.119-1.463-1.832-3.587-2.035-5.416-.355-3.171 1.057-7.361 2.912-11.01C281 52.62 293.053 30.41 266.883 23.94c-6.028-1.431-14.784-2.716-26.073 2.023-6.586 2.765-5.127 4.39-2.768 5.264'
      fill='#F2F2F2'
    />
    <path
      d='m243.869 22.935-7.579 2.83a5.04 5.04 0 0 0-2.964 6.491l.375 1.002a5.063 5.063 0 0 0 6.51 2.956l7.581-2.829a5.04 5.04 0 0 0 2.964-6.493l-.376-1a5.063 5.063 0 0 0-6.511-2.957M197.342 31.121l-24.996 9.33a2.52 2.52 0 0 0-1.483 3.245l.099.263a2.533 2.533 0 0 0 3.256 1.478l24.996-9.33a2.52 2.52 0 0 0 1.483-3.246l-.099-.263a2.53 2.53 0 0 0-3.256-1.477M204.32 49.71l-24.998 9.328a2.52 2.52 0 0 0-1.481 3.246l.097.263a2.53 2.53 0 0 0 3.256 1.477l24.997-9.328a2.52 2.52 0 0 0 1.483-3.246l-.099-.264a2.53 2.53 0 0 0-3.255-1.477'
      fill='#D1D1D6'
    />
    <path
      d='m227.399 18.436-20.26 7.56a5.04 5.04 0 0 0-2.965 6.493l6.918 18.43a5.06 5.06 0 0 0 6.51 2.955l20.261-7.56a5.04 5.04 0 0 0 2.964-6.493l-6.917-18.43a5.063 5.063 0 0 0-6.511-2.955'
      fill='#111'
    />
    <path
      d='m209.232 23.27-20.26 7.562a5.04 5.04 0 0 0-2.964 6.492l8.252 21.987a5.063 5.063 0 0 0 6.51 2.956l20.261-7.56a5.04 5.04 0 0 0 2.964-6.493l-8.253-21.987a5.06 5.06 0 0 0-6.51-2.957'
      fill='#111'
    />
    <path
      d='m212.404 18.808-.159.06a3.36 3.36 0 0 0-1.977 4.328l11.561 30.802a3.375 3.375 0 0 0 4.34 1.971l.159-.06a3.36 3.36 0 0 0 1.976-4.327l-11.56-30.803a3.375 3.375 0 0 0-4.34-1.97'
      fill='#D1D1D6'
    />
    <path
      d='M5.818 38.501S46.508 27.1 40.6 53.37c-1.026 4.157-15.794 25.559 1.797 35.835 3.777 2.206 8.136 3.183 12.513 3.16 7.848-.04 20.29-1.546 25.878-7.219 7.491-7.603-.692-3.998-.692-3.998s-23.369 9.586-35.39 1.945c-4.106-2.609-5.966-7.66-4.852-12.386a28.4 28.4 0 0 1 2.582-6.74C45.051 59.083 57 36.819 30.831 30.349c-6.029-1.432-14.785-2.717-26.075 2.022-11.29 4.74 1.062 6.13 1.062 6.13'
      fill='#F2F2F2'
    />
    <path
      d='m86.26 75.27-7.58 2.829a5.04 5.04 0 0 0-2.964 6.492l.375 1a5.06 5.06 0 0 0 6.511 2.957l7.58-2.829a5.04 5.04 0 0 0 2.964-6.492l-.376-1a5.063 5.063 0 0 0-6.51-2.958'
      fill='#D1D1D6'
    />
    <path
      d='m99.066 62.834-11.234 4.193a5.04 5.04 0 0 0-2.964 6.492l5.417 14.432a5.063 5.063 0 0 0 6.51 2.957l11.234-4.193a5.04 5.04 0 0 0 2.964-6.493l-5.416-14.431a5.063 5.063 0 0 0-6.511-2.957'
      fill='#111'
    />
    <path
      d='m117.767 51.722-16.752 6.253a5.04 5.04 0 0 0-2.965 6.492l8.253 21.987a5.06 5.06 0 0 0 6.51 2.957l16.752-6.252a5.04 5.04 0 0 0 2.965-6.493l-8.252-21.987a5.063 5.063 0 0 0-6.511-2.957'
      fill='#111'
    />
    <path
      d='m121.316 47.17-.159.058a3.36 3.36 0 0 0-1.976 4.328l11.56 30.803a3.375 3.375 0 0 0 4.34 1.97l.159-.06a3.36 3.36 0 0 0 1.977-4.328L125.656 49.14a3.375 3.375 0 0 0-4.34-1.97'
      fill='#D1D1D6'
    />
    <path
      d='M164.093 27.546a2.34 2.34 0 0 1-2.078-2.497l1.25-22.767c.074-1.36 1.226-2.393 2.533-2.272l1.821.168c1.307.12 2.242 1.345 2.059 2.695l-3.071 22.599a2.35 2.35 0 0 1-.839 1.54 2.37 2.37 0 0 1-1.675.534M153.301 29.508a1.5 1.5 0 0 1-.58.053 1.5 1.5 0 0 1-.999-.545 1.5 1.5 0 0 1-.27-.513l-4.464-14.162a1.593 1.593 0 0 1 1.032-2.008l1.155-.349a1.5 1.5 0 0 1 1.19.155 1.48 1.48 0 0 1 .693.977l3.309 14.51a1.595 1.595 0 0 1-1.066 1.882M147.277 37.675c-.799.989-2.408.977-3.647-.026l-21.981-17.81c-1.314-1.064-1.701-2.825-.853-3.872l1.183-1.46c.849-1.05 2.59-.963 3.833.188l20.801 19.271c1.171 1.085 1.464 2.722.664 3.71M157.439 83.676a2.34 2.34 0 0 1 1.371 2.944l-7.04 21.693c-.421 1.296-1.798 2.001-3.032 1.551l-1.718-.625c-1.232-.449-1.824-1.873-1.301-3.13l8.757-21.067a2.364 2.364 0 0 1 2.963-1.366M168.376 84.528a1.49 1.49 0 0 1 1.401.878c.08.177.124.37.129.566l.689 14.828c.022.423-.124.836-.408 1.151a1.6 1.6 0 0 1-1.104.528l-1.207.042a1.5 1.5 0 0 1-1.439-.969 1.5 1.5 0 0 1-.091-.604l.518-14.87a1.594 1.594 0 0 1 1.512-1.55M176.292 78.165c1.026-.752 2.578-.33 3.518.955l16.693 22.817c.996 1.363.92 3.163-.169 3.96l-1.517 1.111c-1.089.798-2.752.271-3.659-1.159L175.982 81.92c-.853-1.346-.716-3.003.31-3.755'
      fill='#F9C6C8'
    />
  </svg>
);
